import React from "react";
import { Button, Checkbox, Form, Input, InputNumber } from "antd";

const LABEL_WIDTH = 180;

const formItemLayout = {
  labelCol: { flex: `0 0 ${LABEL_WIDTH}px` },
  wrapperCol: { flex: "1 1 auto" },
  labelAlign: "right"
};

const newGuid = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID().replace(/[{}]/g, "");
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

/**
 * Вкладка «Основная» — поля карточки сотрудника.
 */
const SprSotrMain = ({ form, isNew = false, disabled = false }) => {
  const isDel = Form.useWatch("isDel", form);

  return (
    <div className="spr-sotr-card__tab">
      <div className="spr-sotr-card__body">
        <Form form={form} className="spr-sotr-card__form" {...formItemLayout} colon={false} disabled={disabled}>
          {!isNew ? (
            <Form.Item label="#" name="idSotr">
              <Input disabled />
            </Form.Item>
          ) : null}
          <Form.Item
            label="Имя пользователя"
            name="name"
            rules={[{ required: true, message: "Укажите имя пользователя" }]}
          >
            <Input maxLength={80} />
          </Form.Item>
          <Form.Item label="Полное имя" name="fullName">
            <Input maxLength={120} />
          </Form.Item>
          <Form.Item label="Должность" name="dolj">
            <Input maxLength={80} />
          </Form.Item>
          <Form.Item label="СНИЛС" name="snils">
            <Input maxLength={20} />
          </Form.Item>
          <Form.Item label="ИНН" name="inn">
            <Input maxLength={20} />
          </Form.Item>
          <Form.Item label="Комментарий" name="komment">
            <Input.TextArea rows={2} maxLength={500} />
          </Form.Item>
          <Form.Item label="Лечащий врач" name="isVrach" valuePropName="checked">
            <Checkbox disabled={Boolean(isDel)} />
          </Form.Item>
          <Form.Item label="Телефон" name="phone">
            <Input maxLength={40} />
          </Form.Item>
          <Form.Item label="CRM телефон" name="crmPhone">
            <Input maxLength={40} />
          </Form.Item>
          <Form.Item label="CRM пользователь" name="crmUser">
            <Input maxLength={80} />
          </Form.Item>
          <Form.Item label="Пароль кассира ККМ" name="kkmPass">
            <Input.Password maxLength={40} visibilityToggle />
          </Form.Item>
          <Form.Item label="Уровень доступа" name="userLevel">
            <InputNumber style={{ width: "100%" }} min={0} max={999} precision={0} />
          </Form.Item>
          <Form.Item label="Код должности ЕГИСЗ" name="positionId">
            <InputNumber style={{ width: "100%" }} min={0} precision={0} />
          </Form.Item>
          <Form.Item label="Код специализации ЕГИСЗ" name="specId">
            <InputNumber style={{ width: "100%" }} min={0} precision={0} />
          </Form.Item>
          <Form.Item label="Ключ (Онлайн сервисы)" name="onlineKey">
            <Input
              maxLength={64}
              addonAfter={
                <Button
                  type="link"
                  size="small"
                  disabled={disabled}
                  onClick={() => form.setFieldsValue({ onlineKey: newGuid() })}
                  style={{ padding: 0, height: "auto" }}
                >
                  Создать
                </Button>
              }
            />
          </Form.Item>
          <Form.Item label="ID эл. подписи" name="signId">
            <Input maxLength={80} />
          </Form.Item>
          <Form.Item
            label="Удалён"
            name="isDel"
            valuePropName="checked"
            getValueFromEvent={(e) => {
              const checked = e.target.checked;
              if (checked) {
                form.setFieldsValue({ isVrach: false });
              }
              return checked;
            }}
          >
            <Checkbox />
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default SprSotrMain;
